import axios from 'src/utils/httpClients/axios';

import { HOST_API } from 'src/config';
import {
  WorkflowSubjectType,
  WorkflowSubjectStateDto,
  WorkflowStepAssigneeOverrides,
} from 'src/@types/workflow/types';

const ROUTE_SEGMENT: Record<WorkflowSubjectType, string> = {
  document: 'documents',
  'form-template': 'form-templates',
  folder: 'folders',
};

const subjectUrl = (subjectType: WorkflowSubjectType, subjectId: number) =>
  `${HOST_API}${ROUTE_SEGMENT[subjectType]}/${subjectId}/workflow-binding`;

export async function getWorkflowBinding(
  subjectType: WorkflowSubjectType,
  subjectId: number,
  signal?: AbortSignal
): Promise<WorkflowSubjectStateDto> {
  const response = await axios.get<WorkflowSubjectStateDto>(subjectUrl(subjectType, subjectId), {
    signal,
  });

  return response.data;
}

export async function bindWorkflow(
  subjectType: WorkflowSubjectType,
  subjectId: number,
  definitionNumber: number,
  stepAssigneeOverrides?: WorkflowStepAssigneeOverrides
): Promise<WorkflowSubjectStateDto> {
  const response = await axios.put<WorkflowSubjectStateDto>(subjectUrl(subjectType, subjectId), {
    definitionNumber,
    stepAssigneeOverrides,
  });

  return response.data;
}

export async function unbindWorkflow(
  subjectType: WorkflowSubjectType,
  subjectId: number
): Promise<void> {
  await axios.delete(subjectUrl(subjectType, subjectId));
}
